export default Object.freeze({
  domains: {},
  keySpaces: {},
});
